import PropTypes from 'prop-types';
import { useFeatureFlagStore } from '@medifind/zustand';
const dev = ['DEV', 'LOCAL'].includes(process.env.NX_ENV);

const FeatureFlag = ({ flagName, children }) => {
  const { flags } = useFeatureFlagStore();
  return !!flags[flagName] || (flags['ALL'] && dev) ? children : null;
};

FeatureFlag.propTypes = {
  flagName: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export function useFeatureFlag(flagName) {
  const { flags } = useFeatureFlagStore();
  return !!flags[flagName] || (flags['ALL'] && dev);
}
export const withFeatureFlags = (reduxFlags) => (WrappedComponent) => {
  const Wrapper = (props) => {
    const { flags } = useFeatureFlagStore();
    return (
      <WrappedComponent
        {...props}
        {...reduxFlags.reduce((t, flagName) => ({ ...t, [`FEATURE_FLAG_${flagName}`]: !!flags[flagName] || (flags['ALL'] && dev) }), {})}
      />
    );
  };
  Wrapper.getInitialProps = WrappedComponent.getInitialProps;
  Wrapper.origGetInitialProps = WrappedComponent.origGetInitialProps;
  Wrapper.getStaticProps = WrappedComponent.getStaticProps;
  Wrapper.getServerSideProps = WrappedComponent.getServerSideProps;
  Wrapper.getStaticPaths = WrappedComponent.getStaticPaths;
  return Wrapper;
};
export const getStaticFeatureFlag = (flag) => {
  const flags = process.env.NX_FEATURE_FLAGS
    ? JSON.parse(process.env.NX_FEATURE_FLAGS).reduce((acc, flag) => {
        acc[flag] = true;
        return acc;
      }, {})
    : {};
  return (flags['ALL'] && dev) || flags[flag];
};

export { FeatureFlag as default, FeatureFlag };
